import React from 'react';

import './styles.css';
import Score from '../Score';

type Props = {
  columns: string[];
  sectionName: string;
  onesScore: number;
  setOnesScore: any;
  sectionScore: number;
  setSectionScore: any;
};

const UpperSection = ({
  columns,
  sectionName,
  onesScore,
  setOnesScore,
  sectionScore,
  setSectionScore,
}: Props) => {

  const rows = [
    'Ones',
    'Twos',
    'Threes',
    'Fours',
    'Fives',
    'Sixes',
  ];

  function changeValue(rowName: string, amount: number) {
    if (rowName === 'Ones') {
      setOnesScore(onesScore + amount);
    }
    setSectionScore(sectionScore + amount);
  }

  return (
    <div>
      <div className={'section-name'}>{sectionName}</div>
      <div className={'scoring-section'}>
        <div className={'scoring-column'}>
          <div className={'column-name'}>Name</div>
          {
            rows.map(row => (<div className={'row'} key={`${sectionName}-rowName-${row}`}><div className={'row-name'}>{row}</div></div>))
          }
        </div>
        {columns.map(columnName =>
          (
            <div className={'scoring-column'} key={`${sectionName}-${columnName}`}>
              <div className={'column-name'}>{columnName}</div>
              {
              rows.map(row => (<div className={'row'} key={`${sectionName}-${columnName}-${row}`}><Score callback={(amount: number) => changeValue(row, amount)} /></div>))
              }
            </div>
          )
        )}
      </div>
    </div>
    );
};

export default UpperSection;